import axios from '../axiosConfig'; 
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;


const submitOrder = async (data) => {
  console.log('Submitting order with data:', data);
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post('/order/add', { ...data}, { headers });
    console.log('Order submission response:', response);
    
    // Return the response data instead of the entire response object
    return response.data;
  } catch (error) {
    console.error('Error creating order:', error);
    // Return error in the same format as success response
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Order submission failed',
      error: error
    };
  }
};


const fetchOrder = async (orderId) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.get(`/order/view/${orderId}`,{ headers });
    return response.data;
  } catch (error) {
    console.error('Error fetching order details:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to fetch order',
      error: error
    };
  }
};

const fetchOrders = async (page = 1, perPage = 10, filters = {}) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    // Correct way to pass query parameters
    const params = { page, per_page: perPage, ...filters };
    const response = await axios.get('/order/list', { 
      headers,
      params 
    });
    
    console.log('fetchOrders API Response:', response.data); // Debug logging
    return response.data; 
  } catch (error) {  
    console.error('Error fetching orders:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to fetch orders',
      error: error
    };
  }
};

const modifyOrder = async (orderId, status, discount) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post(`/order/modify/${orderId}`, { status, discount }, { headers });
    return response.data;
  } catch (error) {
    console.error('Error modifying order:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to modify order',
      error: error
    };
  }
};

const deleteOrder = async (orderId) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.get('/order/delete' ,{orderId:orderId}, { headers }); 
    return response.data;
  } catch (error) {
    console.error('Error deleting order:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to delete order',
      error: error
    };
  }
};

const addBillInfo = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  try {
     
    const response = await axios.post('/logistics/billing/add', {...data}, {
      headers: headers
    });
    console.log('Billing info response:', response);
     
    return response.data;
  } catch (error) { 
    console.error('Error adding billing info:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to add billing info',
      error: error
    };
  }
}; 
const fetchPayment= async (orderId) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.get(`/payment-status/${orderId}`,{ headers });
    return response.data;
  } catch (error) {
    console.error('Error fetching payment status:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to fetch payment status',
      error: error
    };
  }
};
const confirmCODPayment = async (orderId, notes = '') => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post(`/order/confirm-cod-payment/${orderId}`, 
      { notes: notes || 'Cash collected upon delivery' }, 
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error('Error confirming COD payment:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to confirm COD payment',
      error: error
    };
  }
};

export { baseURL, submitOrder ,fetchOrder, fetchOrders, modifyOrder,deleteOrder,addBillInfo,fetchPayment, confirmCODPayment};